import { Typography, useTheme } from '@mui/joy';
import { Plus } from '@phosphor-icons/react';

import { Color, Level } from 'theme/enums';

import { FlexBox } from './FlexBox';

interface IProps {
  title: string;
  onClick: () => void;
}

export const AddButton = ({ title, onClick }: IProps) => {
  const theme = useTheme();

  return (
    <FlexBox
      sx={{
        justifyContent: 'center',
        borderRadius: 6,
        border: `2px dashed ${theme.palette.primary[300]}`,
        backgroundColor: theme.palette.neutral[50],
        cursor: 'pointer',
        padding: '12px 16px',

        '&:hover': {
          backgroundColor: theme.palette.neutral[100],
        },
      }}
      onClick={onClick}
    >
      <Typography
        level={Level.TITLE_SM}
        color={Color.PRIMARY}
        startDecorator={<Plus size={20} weight="bold" />}
        fontWeight={600}
      >
        {title}
      </Typography>
    </FlexBox>
  );
};
